import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import {Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import InputAdornment from '@mui/material/InputAdornment';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import AgentSelect from '../agents/AgentSelect';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Portal from '@mui/base/Portal';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
// import DateTimePicker from '@mui/lab/DateTimePicker';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import axios from 'axios';
import Autocomplete from '../components/Autocomplete';

import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const navigate = useNavigate();
  const userObj = useSelector(state => state.userDetails);
  const childRefUser = React.useRef();
  const [formReset, setFormReset] = React.useState(false);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
    
  const [campaignName, setCampaignName] = React.useState("");
  const [campaignStatus, setCampaignStatus] = React.useState("Planned");
  const [description, setDescription] = React.useState("");
  const [expectedResponse, setExpectedResponse] = React.useState(0);
  const [budgetedCost, setBudgetedCost] = React.useState(0);
  const [actualCost, setActualCost] = React.useState(0);
  const [expectedRevenue, setExpectedRevenue] = React.useState(0);
  const [accessType, setAccessType] = React.useState(1);
  const [ownerAlias, setOwnerAlias] = React.useState("");
  const [ownerId, setOwnerId] = React.useState(0);

  var myCurrentDate=new Date();
	var myDate=new Date(myCurrentDate);
  myDate.setDate(myDate.getDate() + 10);
	const [startDate, setStartDate] = React.useState(moment(myDate).format('YYYY-MM-DD'));
	var myToDate=new Date(myCurrentDate);
  myToDate.setDate(myToDate.getDate() + 40);
  const [endDate, setEndDate] = React.useState(moment(myToDate).format('YYYY-MM-DD'));
  

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setFormReset(!formReset);
      setOpen(true);
    }
  }));
  
  const handleClose = () => {    
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    setSaveLoading(false);
    
    if(props.dataObj && props.dataObj.autoId){
      setCampaignName(props.dataObj.campaignName);
      setCampaignStatus(props.dataObj.campaignStatus);
      setDescription(props.dataObj.description);
      setExpectedResponse(props.dataObj.expectedResponse);
      setBudgetedCost(props.dataObj.budgetedCost);
      setActualCost(props.dataObj.actualCost);
      setExpectedRevenue(props.dataObj.expectedRevenue);
      if(props.dataObj.accessType){
        setAccessType(props.dataObj.accessType);
      }else{
        setAccessType(1);
      }
      setOwnerAlias(props.dataObj.ownerAlias);
      setOwnerId(props.dataObj.ownerId);

    }else{
      setCampaignName("");
      setCampaignStatus("Planned");
      setDescription("");
      setExpectedResponse(0);
      setBudgetedCost(0);
      setActualCost(0);
      setExpectedRevenue(0);
      setOwnerAlias(props.userObj.fullName);
      setOwnerId(props.userObj.userId);
      setAccessType(1);
          
    }

	}, [props.dataObj,open]);
  

	function saveData(){
    if(!campaignName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter campaign name");			
      return false;
    }

    if(campaignName){ 
			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': userObj.registerId,
          'uid': userObj.loginId,
          'fullName': userObj.fullName,
          'token': userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }
      data.append('campaignName', campaignName);
      data.append('campaignStatus', campaignStatus);
      data.append('description', description);
      data.append('expectedResponse', expectedResponse);
      data.append('budgetedCost', budgetedCost);
      data.append('actualCost', actualCost);
      data.append('expectedRevenue', expectedRevenue);

      data.append('accessType', accessType);
      data.append('ownerAlias', ownerAlias);
      data.append('ownerId', ownerId);

      if(startDate){
        data.append('startDate', moment(startDate).format('YYYY-MM-DD'));
      }
      if(endDate){
        data.append('endDate', moment(endDate).format('YYYY-MM-DD'));
      }

      if(props.fullList===true){
        data.append('fullList', 1);
      }else{
        data.append('fullList', 0);
      }

      let apiURL='/crm-create-campaigns';
      if(props.dataObj && props.dataObj.autoId>0){
          apiURL='/crm-update-campaigns';
      }
      setSaveLoading(true);       
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);        
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt); mobileExists
				if(response.data.responseTxt==="success"){
          setFormReset(!formReset);
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Campaign has been saved.");
          props.updatedList();
					return false;

        }else if(response.data.responseTxt==="alreadyexistserror"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Campaign is already exists");			
					return false;  

        }else if(response.data.responseTxt==="limitexceeded"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Your app records limit exceeded. You must upgrade your package to add more data.");			
					return false;  

				}else if(response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Campaign could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}



    function selectUser(){
      childRefUser.current.handleClickOpen();
    }
    function userDetail(obj) {
      setOwnerId(obj.autoId);
      setOwnerAlias(obj.fullName);    
    }
  
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >
                  <div className="btmbdrgry"><h4>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} Campaign</h4></div>

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>                          
                          <Grid item md={6} xs={12} >
                              <TextField label="Campaign Name" onChange={event => setCampaignName(event.target.value)} value={campaignName} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <FormControl fullWidth size='small' >
                                      <InputLabel id="demo-simple-select-label">Campaign Status</InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={campaignStatus}
                                        label="Campaign Status"
                                        onChange={event => setCampaignStatus(event.target.value)}
                                      >
                                        <MenuItem value="Planned" >Planned</MenuItem>
                                        <MenuItem value="Open" >Open</MenuItem>
                                        <MenuItem value="Cancelled" >Cancelled</MenuItem>
                                        <MenuItem value="Completed" >Completed</MenuItem>
                                      </Select>
                              </FormControl>
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField 
                                label="Start Date"
                                id="date"                                
                                type="date"
                                size='small'
                                defaultValue={startDate}
                                fullWidth
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={event => setStartDate(event.target.value)}
                                variant="outlined"
                                />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField 
                                label="End Date"
                                id="date"                                
                                type="date"
                                size='small'
                                defaultValue={endDate}
                                fullWidth
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={event => setEndDate(event.target.value)}
                                variant="outlined"
                                />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Description" onChange={event => setDescription(event.target.value)} value={description} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Expected Response" onChange={event => setExpectedResponse(event.target.value)} value={expectedResponse} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Budgeted Cost" onChange={event => setBudgetedCost(event.target.value)} value={budgetedCost} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Actual Cost" onChange={event => setActualCost(event.target.value)} value={actualCost} fullWidth variant="outlined" size='small' />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Expected Revenue" onChange={event => setExpectedRevenue(event.target.value)} value={expectedRevenue} fullWidth variant="outlined" size='small' />
                          </Grid>

                          <Grid item md={6} xs={12} >
                              <Grid container spacing={2} >
                                  <Grid item md={8} xs={8} >
                                      <TextField
                                        label="Agent"
                                        onChange={event => setOwnerAlias(event.target.value)}
                                        value={ownerAlias}
                                        fullWidth
                                        size='small'
                                        variant="outlined"
                                        
                                        InputProps={{
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <SavedSearchIcon style={{cursor:'pointer'}} onClick={()=>{selectUser()}} />
                                            </InputAdornment>
                                          ),
                                          }}
                                    />
                                  </Grid>
                                  <Grid item md={4} xs={4} >
                                    <FormControl fullWidth size='small'  >
                                      <InputLabel id="demo-simple-select-label">Visibility</InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={accessType}
                                        label="Visibility"
                                        onChange={event => setAccessType(event.target.value)}
                                      >
                                        <MenuItem value={1} >Public</MenuItem>
                                        <MenuItem value={2} >Private</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                              </Grid>
                          </Grid>
                          


                    </Grid>
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {saveLoading?
                            <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{marginRight:20, backgroundColor:'#ea1072',color:'#FFF'}}  size="small" variant="contained" >Saving...</LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }
                            
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Portal>
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>
      </Portal>

      <AgentSelect userObj={props.userObj} fetchDetail={userDetail} fetch={true} ref={childRefUser} />

    </>
  );

});

export default CustomizedDialogs;